import Dialog from './Dialog.js';

class InstitutionSignInDialog extends Dialog {
    static create({id, env}) {
        return new InstitutionSignInDialog({id, decorator: env.getDecorator()});
    }

    constructor({id, decorator}) {
        super({id, autoInitEvents: false});

        this.formEl = decorator.sectionError(this.find('.dialog-right-pane'));
        this.usernameField = decorator.errorAndEnterKeyPress(this.find('.name-input'));
        this.passwordField = decorator.errorAndEnterKeyPress(this.find('.password-input'));
        this.signInButton = decorator.spinnerButton(this.find('.sign-in-button'));

        this.initEvents();
    }

    initEvents() {
        super.initEvents();

        this.usernameField.on('enterKeyPress', () => this.onSubmitGesture());
        this.passwordField.on('enterKeyPress', () => this.onSubmitGesture());
        this.signInButton.click(() => this.onSubmitGesture());
    }

    addFormError(error) {
        this.formEl.addError(error);
    }

    addPasswordRequiredError() {
        this.passwordField.addError('Please provide a valid password to sign in.');
    }

    addUsernameRequiredError() {
        this.usernameField.addError('Please provide a valid institution name to sign in.');
    }

    focusPassword() {
        this.passwordField.focus();
    }

    focusUsername() {
        this.usernameField.focus();
    }

    getState() {
        return {username: this.usernameField.val(), password: this.passwordField.val()};
    }

    onSubmitGesture() {
        this.maybeTrigger('submitGesture');
    }

    setPassword(password) {
        this.passwordField.val(password);
    }

    setSubmitting(submitting) {
        this.setEventsEnabled(!submitting);
        this.signInButton.toggleSpinner(submitting);
    }

    setUsername(username) {
        this.usernameField.val(username);
    }
}

export default InstitutionSignInDialog;